import axios from "axios";
import configJson from "../config.json";

const { hostname } = window.location;
const conf = configJson.find((c) => c.key === hostname);
axios.defaults.baseURL = conf?.endpoint;
axios.defaults.withCredentials = true;
// Add a request interceptor
axios.interceptors.request.use((config: any) => {
  const newConfig = config;
  newConfig.withCredentials = true;

  return newConfig;
});
/**
 * Will unpack the response body from reponse object
 * @param {*} response
 *
 */
const onGlobalSuccess = (response: any) => response.data;
const onGlobalError = (err: any) => Promise.reject(err);
// const API_HOST_PREFIX = process.env.REACT_APP_API_HOST_PREFIX;
// const API_NODE_HOST_PREFIX = process.env.REACT_APP_API_NODE_HOST_PREFIX;

const API_HOST_PREFIX = "";
const API_NODE_HOST_PREFIX = "";
export { onGlobalError, onGlobalSuccess, API_HOST_PREFIX, API_NODE_HOST_PREFIX };
